import { useState } from 'react'
import { Collapse, DialogContent, Typography } from '@mui/material'

//components
import { ConnectGmailButton } from '../ConnectGmailButton'
//types
import { GmailConnectionModalContentProps } from 'types'

const GmailConnectionStart = ({ hideModal }: GmailConnectionModalContentProps) => {
  const [isMoreInfoOpen, setIsMoreInfoOpen] = useState(false)

  return (
    <DialogContent sx={styles.dialogContent}>
      <Typography sx={styles.text} variant="body2">
        Connect your gmail to earn rewards with every mobile game purchase. Even on offers outside
        of Playback!
      </Typography>

      <ConnectGmailButton hideModal={hideModal} />
      <Collapse in={isMoreInfoOpen} timeout="auto" unmountOnExit>
        <Typography sx={styles.moreText} variant="body2">
          Playback detects when a new eReceipt is sent to your gmail and rewards you for that
          purchase. The purchase can be from any mobile game. As long as you recieve a Google Play
          or Apple App Store eReceipt to the connected email, you will receive a reward. It doesn’t
          need to be a Playback partner game.
        </Typography>
        <br></br>
        <Typography sx={styles.moreText} variant="body2">
          <strong>Security:</strong> Playback only receives information from your mobile game
          receipts. No other information is processed.
        </Typography>
      </Collapse>
      <Typography
        sx={(styles.text, styles.moreInfo)}
        variant="body2"
        onClick={() => (isMoreInfoOpen ? hideModal() : setIsMoreInfoOpen(true))}
      >
        {isMoreInfoOpen ? 'Maybe Later' : 'More Info'}
      </Typography>
    </DialogContent>
  )
}

const styles = {
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  headlineText: {
    fontWeight: 800,
    color: '#0F172A',
    fontSize: {
      xs: '14px',
    },
    textAlign: 'center',
  },
  text: {
    fontWeight: 500,
    color: '#0F172A',

    fontSize: {
      xs: '14px',
    },
    lineHeight: {
      xs: '22px',
    },
    textAlign: 'center',
  },
  moreText: {
    color: '#0F172A',
    lineHeight: {
      xs: '16px',
    },
    fontSize: {
      xs: '10px',
    },
    fontWeight: 500,
  },
  moreInfo: {
    fontWeight: 500,
    color: '#F59E0B',
    textDecoration: 'underline',
    fontSize: {
      xs: '16px',
    },
    textAlign: 'center',
    '&:hover': {
      color: '#D97706', // darker amber on hover
      cursor: 'pointer', // example: remove underline on hover
    },
  },
}

export default GmailConnectionStart
